import * as React from 'react'

import clsx from 'clsx'
import { ErrorMessage } from '../ErrorMessage'

const TextInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { label?: string; error?: string }
>(({ className, label, placeholder = 'Input', type, ...props }, ref) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="sr-only">{placeholder}</label>
      <label className="text-xs" htmlFor={props.name}>
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        className={clsx(
          'bg-transparent rounded-md border-2 border-primary transition-all ease-in-out focus-visible:pl-6 h-10 px-4 text-xs ',
          className
        )}
        ref={ref}
        {...props}
      />
      <ErrorMessage error={props.error} />
    </div>
  )
})
TextInput.displayName = 'TextInput'

export { TextInput }
